import { styled } from "@mui/material"

import { Dialog } from "../index"

export const CompactDialog = styled(Dialog)(({ hideTitle }) => ({
    "&[class*=MuiDialog-root]": {
      "& .MuiPaper-root": {
        padding: "14px 24px",
        background: "#FFFFFF"
      }
    },

    "& .MuiDialogTitle-root": {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "20px",
      display: hideTitle ? "none" : "initial"
    }

  })
)
